import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AcordianComponent } from './acordian/acordian.component';
import { CommonModule, DatePipe } from '@angular/common';
import { CommentsComponent } from './comments/comments.component';
import { Toggler } from './toggler/toggler.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { LottieComponent } from './lottie/lottie.component';
import { LottieModule } from 'ngx-lottie';
import { ContentMenuComponent } from './content-menu/content-menu.component';
import { InstagramBanerComponent } from '../routes/Home/components/instagram-baner/instagram-baner.component';
import { VoicePlayerComponent } from './voice-player/voice-player.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConsultationFormComponent } from '../routes/Home/components/consultation-form/consultation-form.component';
import { SectorFilterComponent } from '../routes/calendar/sector-filter/sector-filter.component';
import { FilterPipe } from 'src/ts/filterNgfor.pipe';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { DatePickerComponent } from '../routes/calendar/date-picker/date-picker.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {DefaultMatCalendarRangeStrategy,MatRangeDateSelectionModel,} from '@angular/material/datepicker';
import { ProductProperties } from './product-properties/product-properties.component';
import { RatingComponent } from './rating/rating.component';
import { CounselingNeedsBannerComponent } from './counseling-needs-banner/counseling-needs-banner.component';
import { InstagramBanerSharedComponent } from './instagram-baner-shared/instagram-baner-shared.component';
import { BlogCartComponent } from '../routes/Blog/components/blog-cart/blog-cart.component';
import { ModalComponent } from './modal/modal.component';
import { VideoPlayerNewComponent } from './video-player-new/video-player-new.component';
// import { GifCarouselComponent } from './gif-carousel/gif-carousel.component';
import { JalaliDatePipe } from '../classes/pipe/jalali-date.pipe';
import { SchemaComponent } from './schema/schema.component';
import { ExternalLinkDirective } from '../classes/directives/Externallink.directive';
import { BlogSliderComponent } from './blog-slider/blog-slider.component';

const components = [
  AcordianComponent,
  CommentsComponent,
  DatePickerComponent,
  LottieComponent,
  ContentMenuComponent,
  InstagramBanerComponent,
  VoicePlayerComponent,
  ConsultationFormComponent,
  SectorFilterComponent,
  CounselingNeedsBannerComponent,
  InstagramBanerSharedComponent,
  BlogCartComponent,
  VideoPlayerNewComponent,
  // GifCarouselComponent,
  SchemaComponent,
  BlogSliderComponent
];

@NgModule({
  imports: [
   ModalComponent,
    CommonModule,
    Toggler,
    LottieModule,
    FormsModule,
    ReactiveFormsModule,
    NgxTippyModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ProductProperties,
    RatingComponent,
  ],
  exports: [
    components,
    ExternalLinkDirective,
    LottieModule,
    NgxTippyModule,
    ProductProperties,
    RatingComponent,
    JalaliDatePipe
  ],
  declarations: [
    components,
    ExternalLinkDirective,
    NotFoundComponent,
    ContentMenuComponent,
    FilterPipe,
    JalaliDatePipe,
  ],
  providers: [
    DefaultMatCalendarRangeStrategy,
    MatRangeDateSelectionModel,
    DatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
